import {mapState} from "vuex"

export default {
  data() {
    return {
      inputValue: '',
      region: null,
      isOptionsOpen: false,
      additionalOptions: {}
    }
  },
  computed: {
    ...mapState('vacancies', [
      'otherKeys',
      'staticFiltersKeys',
    ]),
    filterQueryParamsNames() {
      return this.$store.state.filter.queryParamsNames
    }
  },
  methods: {
    resetMixin() {
      this.inputValue = ''
      this.region = null
      this.additionalOptions = {}
      this.$refs['options'] && this.$refs['options'].reset()
    },
    onSearchMixin() {
      const params = {}
      const query = {}
      const staticFilters = this.getStaticParams()
      const dynamicFilters = []

      if (this.inputValue.length) {
        query[this.otherKeys.SEARCH] = this.inputValue
      }

      if (this.additionalOptions.direction) {
        query.direction = this.additionalOptions.direction
      }

      if (this.$route.query[this.otherKeys.SORT]) {
        query[this.otherKeys.SORT] = this.$route.query[this.otherKeys.SORT]
      }

      const dynamicParamsObject = this.additionalOptions.dynamic
      for (const k in dynamicParamsObject) {
        dynamicFilters.push(k + '-' + dynamicParamsObject[k].join('|'))
      }

      params.categoriesIds = this.additionalOptions.categories

      if (staticFilters.length && dynamicFilters.length) {
        params.staticFilters = staticFilters
        params.dynamicFilters = dynamicFilters

        this.$router.push({
          name: 'vacancies-with-static&dynamic',
          params,
          query
        })

      } else if (dynamicFilters.length) {
        params.dynamicFilters = this.additionalOptions.dynamic

        this.$router.push({
          name: 'vacancies-with-dynamic',
          params,
          query
        })
      } else if (staticFilters.length) {
        params.staticFilters = staticFilters

        this.$router.push({
          name: 'vacancies-with-static',
          params,
          query
        })
      } else {
        delete params.staticFilters

        if (this.additionalOptions.direction) {
          this.$router.push({
            name: 'vacancies',
            params,
            query
          })
        } else {
          this.$router.push({
            name: 'vacancies',
            params,
            query
          })
        }
      }

      this.resetMixin()
      this.$emit('search')

      if (typeof this.afterSearch === 'function') {
        this.afterSearch()
      }

      // if(query[this.otherKeys.SEARCH]) {
      //   this.$store.dispatch('sendAlert', {
      //     type: 'input',
      //     title: 'Search query',
      //     query: `${[this.otherKeys.SEARCH]}=${query[this.otherKeys.SEARCH]}`
      //   })
      // }
    },
    getStaticParams() {
      const newFilters = []
      if (this.region) {
        if (this.region.type === 'country') {
          newFilters.push(`${this.staticFiltersKeys.COUNTRY}-${this.region.id}`)
        } else if (this.region.type === 'city') {
          newFilters.push(`${this.staticFiltersKeys.CITY}-${this.region.id}`)
        }
      }

      return newFilters
    }
  }
}
